import theme from '@babelcoder/gatsby-theme-base/src/theme/base'

export default {
  maxWidth: {
    medium: '768px',
    large: '1100px',
  },
  gutter: theme.spacers.medium,
}
